import * as React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { Classes, Alert, HTMLTable, Dialog, Button } from '@blueprintjs/core';
import { AppStore } from '../../stores/AppStore';
import { EmpresaStore } from '../../stores/empresa/EmpresaStore';
import * as moment from 'moment';
import { MDBRow, MDBCol, MDBBtn } from "mdbreact";
import { ResultadoStore } from '../../stores/resultados/ResultadoStore'
import { IEmpresaRetroativa, IEmpresaErrosSefaz, newEmpresa } from '../../model';
import { NotificacoesStore } from '../../stores/notificacoes/NotificacoesStore';
import { toast } from "react-toastify";
import {
  Chart,
  Geom,
  Axis,
  Tooltip,
  Legend
} from "bizcharts";
import { LookupStore } from '../../stores/LookupStore';
import { PerfilStore } from '../../stores/perfil/PerfilStore';
import { CentralStore } from '../../stores/erros/CentralStore';
import { ErrosNotasStore } from '../../stores/erros/ErrosNotasStore';
import { IconButton } from '@mui/material';
import { AppIcon } from '../utils/AppIcon';

const numeral = require('numeral');

require('../../assets/css/components/DashboardPage.css');

interface State {
  isTourOpen: boolean,
  isShowingMore: boolean,
}

@observer
export class DashboardPage extends React.Component<{}, State> {

  obs = observable({
    data: [] as [number, number][],
    espaco: "" as string,
    ciencia: "" as string,
    confirmadas: "" as string,
    desconhecidas: "" as string,
    nao_realizadas: "" as string,
    total: "" as string,
    modalNotificacaoAdm: false as boolean,
    empresas_plano_1: 0 as number,
    empresas_plano_2: 0 as number,
    empresas_plano_3: 0 as number,
    empresas_plano_4: 0 as number,
    empresas_plano_5: 0 as number,
    modalBemVindo: false as boolean,
    empresasTrocaPlano: false as boolean,
    modalEspaco: false as boolean,
    countArmaz: 0 as number,
    open_modal_retroativas: false as boolean,
    open_modal_divergentes: false as boolean,
    open_modal_erros_sefaz: false as boolean,
    open_visualiza_descricao: false as boolean,
    description: "" as string,
  })

  constructor(props: any) {
    super(props);

    this.state = {
      isTourOpen: false,
      isShowingMore: false,
    };
  }

  async componentDidMount() {
    AppStore.setTitle("");
    await AppStore.handleGraphStats()
    await NotificacoesStore.handleConsultaWarnings();

    if (NotificacoesStore.obs.warnings.length >= 1) {
      NotificacoesStore.obs.isTourOpen = true
    }

    ResultadoStore.obs.notasRetroativas = false
    ResultadoStore.obs.notasDivergentes = false

    if (AppStore.obs1.usuario && AppStore.obs1.releases.length) {

      if (!AppStore.obs1.usuario.version_update || AppStore.obs1.usuario.version_update != AppStore.obs1.releases[0].version) {

        // AppStore.setLocation("/releases")
        this.obs.open_visualiza_descricao = true
        this.obs.description = AppStore.obs1.releases[0].description

      }

    }

    let resp_stats: any = await AppStore.statsManifestacoes()

    if (resp_stats.espaco) { this.obs.espaco = resp_stats.espaco; } else { this.obs.espaco = "0"; }
    if (resp_stats.ciencia) { this.obs.ciencia = resp_stats.ciencia; } else { this.obs.ciencia = "0"; };
    if (resp_stats.confirmadas) { this.obs.confirmadas = resp_stats.confirmadas; } else { this.obs.confirmadas = "0"; };
    if (resp_stats.desconhecidas) { this.obs.desconhecidas = resp_stats.desconhecidas; } else { this.obs.desconhecidas = "0"; };
    if (resp_stats.nao_realizadas) { this.obs.nao_realizadas = resp_stats.nao_realizadas; } else { this.obs.nao_realizadas = "0"; };

    let total_number = parseInt(this.obs.ciencia) + parseInt(this.obs.confirmadas) + parseInt(this.obs.desconhecidas) + parseInt(this.obs.nao_realizadas);
    this.obs.total = "" + (Number.isNaN(total_number) ? "" : total_number) + "";

    if (AppStore.obs1.usuario.conta && AppStore.obs1.usuario.conta.notificacao && PerfilStore.obs.alteracaoPlanos.length > 0) {
      this.obs.empresasTrocaPlano = true;
    }

    let permissao = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;
    if (permissao) {
      this.obs.modalBemVindo = true;
    }

    await AppStore.loadEmpresasRetroativas()
    await AppStore.loadEmpresasNotaDivergente()
    await AppStore.loadErrosSefaz()
    await AppStore.checkStatus()
  }


  @action
  async notificacaoVisualizada(): Promise<any> {
    this.obs.modalNotificacaoAdm = false;
    this.obs.empresasTrocaPlano = false;

    await AppStore.notificacaoVisualizada()

  }

  centralAjuda = () => {
    window.open('http://help.fipo.com.br/', '_blank');
  }

  handleCalculos = () => {
    AppStore.setLocation("/resultados");
  }

  handleCalculoICMS(cnpj: string) {
    let empresa = EmpresaStore.getByCnpj(cnpj);

    if (empresa) {
      ResultadoStore.clearAllData();
      let periodo: any = [moment().subtract(30, 'days').toDate(), moment().toDate()]

      AppStore.setSelectedPeriodAndEmpresa(periodo, empresa);
      LookupStore.loadIcmsClassificacoes(empresa.uf)

      AppStore.setLocation("/resultados")

    } else {
      toast.warn("Empresa não localizada, tente novamente mais tarde!", {});
      return
    }
  }

  handleCalculoICMSDivergentes(cnpj: string) {
    let empresa = EmpresaStore.getByCnpj(cnpj);

    if (empresa) {
      ResultadoStore.clearAllData();

      let periodo: any = [moment().subtract(30, 'days').toDate(), moment().toDate()]

      AppStore.setSelectedPeriodAndEmpresa(periodo, empresa);
      LookupStore.loadIcmsClassificacoes(empresa.uf)

      AppStore.setLocation("/resultados");

    } else {
      toast.warn("Empresa não localizada, tente novamente mais tarde!", {});
      return
    }
  }

  handleRedirectErrosSefaz(el: IEmpresaErrosSefaz) {
    let empresa = EmpresaStore.getByCnpj(el.cnpj);

    if (empresa) {
      let periodo: any = [new Date(el.inserted_at), new Date()]

      AppStore.setSelectedPeriodAndEmpresa(periodo, empresa);
      AppStore.setLocation("/logs");
    } else {
      toast.warn("Empresa não localizada, tente novamente mais tarde!", {});
      return
    }

  }

  handleOpenRetroativas() {
    if (AppStore.obs1.empresasRetroativas.length > 0) {
      this.obs.open_modal_retroativas = true
    }
  }

  handleOpenNotasDivergentes() {
    if (AppStore.obs1.empresaNotaDivergente.length > 0) {
      this.obs.open_modal_divergentes = true
    }
  }

  handleOpenErrosSefaz() {
    if (AppStore.obs1.empresaErrosSefaz.length > 0) {
      this.obs.open_modal_erros_sefaz = true
    }
  }

  handleGoErros = () => {
    ErrosNotasStore.obs.imports_length = 0
    ErrosNotasStore.obs.imports_page = 1
    ErrosNotasStore.obs.imports = []
    ErrosNotasStore.obs.selectedEmpresa = newEmpresa()

    AppStore.setLocation("/erros-notas");
  }

  handleGoResultados = () => {
    AppStore.setLocation("/imports");
  }

  handleGoEmpresa = () => {

    EmpresaStore.obs.certificado = ""
    EmpresaStore.obs.status = ""

    AppStore.setLocation("/empresas");

  }

  handleGoCentralAcoes = () => {
    AppStore.setLocation("/central-de-acoes");
  }

  handleGoPerfil = () => {
    AppStore.setLocation("/perfil");
  }

  viewMudancas = () => {
    AppStore.setLocation("/alteracoes-plano");
  }

  cancelAlert = () => {
    // this.obs.showingCertificadosExpirados = false;
    this.obs.modalNotificacaoAdm = false;
    this.obs.modalBemVindo = false;
  }

  handleModalEspaco = () => {
    this.obs.modalEspaco = true;
  }

  handleGrafico() {

    const data = [
      { "name": "Itens Calculados", mes: "Jan", values: AppStore.obs.totalJaneiro },
      { "name": "Itens Calculados", mes: "Fev", values: AppStore.obs.totalFevereiro },
      { "name": "Itens Calculados", mes: "Mar", values: AppStore.obs.totalMarco },
      { "name": "Itens Calculados", mes: "Abr", values: AppStore.obs.totalAbril },
      { "name": "Itens Calculados", mes: "Mai", values: AppStore.obs.totalMaio },
      { "name": "Itens Calculados", mes: "Jun", values: AppStore.obs.totalJunho },
      { "name": "Itens Calculados", mes: "Jul", values: AppStore.obs.totalJulho },
      { "name": "Itens Calculados", mes: "Ago", values: AppStore.obs.totalAgosto },
      { "name": "Itens Calculados", mes: "Set", values: AppStore.obs.totalSetembro },
      { "name": "Itens Calculados", mes: "Out", values: AppStore.obs.totalOutubro },
      { "name": "Itens Calculados", mes: "Nov", values: AppStore.obs.totalNovembro },
      { "name": "Itens Calculados", mes: "Dez", values: AppStore.obs.totalDezembro },

      { "name": "Importação Erros", mes: "Jan", values: AppStore.obs.totalErroJaneiro },
      { "name": "Importação Erros", mes: "Fev", values: AppStore.obs.totalErroFevereiro },
      { "name": "Importação Erros", mes: "Mar", values: AppStore.obs.totalErroMarco },
      { "name": "Importação Erros", mes: "Abr", values: AppStore.obs.totalErroAbril },
      { "name": "Importação Erros", mes: "Mai", values: AppStore.obs.totalErroMaio },
      { "name": "Importação Erros", mes: "Jun", values: AppStore.obs.totalErroJunho },
      { "name": "Importação Erros", mes: "Jul", values: AppStore.obs.totalErroJulho },
      { "name": "Importação Erros", mes: "Ago", values: AppStore.obs.totalErroAgosto },
      { "name": "Importação Erros", mes: "Set", values: AppStore.obs.totalErroSetembro },
      { "name": "Importação Erros", mes: "Out", values: AppStore.obs.totalErroOutubro },
      { "name": "Importação Erros", mes: "Nov", values: AppStore.obs.totalErroNovembro },
      { "name": "Importação Erros", mes: "Dez", values: AppStore.obs.totalErroDezembro },
    ];

    const cols = {
      values: {
        formatter: val => {
          return numeral(val).format("0,0");
        },
      },
    };

    const axisConfig = {
      grid: {
        line: {
          style: {
            stroke: '#cccccc8c',
            lineDash: [3, 3],
          },
        },
      },
    };

    return (
      <Chart height={400} padding={[25, 20, 60, 90]} data={data} scale={cols} autoFit interactions={['active-region']}>
        <Legend position="top" />
        <Tooltip shared />
        <Axis name="values" {...axisConfig} />
        <Geom
          type="interval"
          position="mes*values"
          color={['name', ['#3498db', '#e74c3c']]}
          adjust={[
            {
              type: 'dodge',
              marginRatio: 1 / 72,
            },
          ]}
        />
      </Chart>
    );
  }

  async handleRedirctEmpresas(certificado: string) {

    EmpresaStore.obs.certificado = certificado
    EmpresaStore.obs.status = ""

    AppStore.setLocation("/empresas");

  }

  formatVersion = (version) => {

    return parseInt(version.replace(/\./g, ""))

  }

  async handleEntendi() {

    this.obs.open_visualiza_descricao = false

    if(!AppStore.obs1.usuario.version_update || this.formatVersion(AppStore.obs1.releases[0].version) > this.formatVersion(AppStore.obs1.usuario.version_update)){

      await AppStore.handleUpdatesModal(AppStore.obs1.usuario._id, AppStore.obs1.releases[0].version)

      if (AppStore.obs1.result_ok) {

        await AppStore.loadUsuario()

      }

    }

  }

  render() {

    let total_calculo_armazenamento = (CentralStore.obs.empresasEspaco.reduce(function (acc, obj) { return acc + (obj.armazenamento || 0); }, 0));
    let total_armazenamento = (CentralStore.obs.empresasEspaco.reduce(function (acc, obj) { return acc + (obj.plano || 0); }, 0));

    let empresas_espaco = CentralStore.obs.empresasEspaco?.map(emp => {
      return (
        <tr key={emp.cnpj} className={"nz-table-actions"}>
          <td>{emp.razao_social}</td>
          <td>{numeral(emp.armazenamento * 1000000).format("0 b")}</td>
          <td>{numeral(emp.plano * 1000000).format("0 b")}</td>
        </tr>
      )

    });

    empresas_espaco.push(
      <tr key={""} className={"nz-table-actions"}>
        <td style={{ fontSize: 12 }}><b>Totais</b></td>
        <td style={{ fontSize: 12 }}><b>{numeral(total_calculo_armazenamento * 1000000).format("0 b")}</b></td>
        <td style={{ fontSize: 12 }}><b>{numeral(total_armazenamento * 1000000).format("0 b")}</b></td>
      </tr>
    )

    const itens = Object.keys(PerfilStore.obs.empresas_planos)
      .map((faixa) => parseInt(faixa.match(/\d+/)[0]))
      .sort((a, b) => {
        if (a === 0) return -1;
        if (b === 0) return 1;
        return a - b;
      })
      .map((faixa) => {
        const empresasNessaFaixa = PerfilStore.obs.empresas_planos[`faixa${faixa}`];

        if (faixa == 0) {
          return (<>
            <MDBCol md="2" key={faixa}>
              <h2 className="count_total_second">
                <span className="big-number">{empresasNessaFaixa.length} </span>
                {empresasNessaFaixa.length <= 1 ? " CNPJ" : " CNPJs"} plano <br /> SEFIP
              </h2>
            </MDBCol>
          </>)
        }

        return (
          <MDBCol md="2" key={faixa}>
            <h2 className="count_total_second">
              <span className="big-number">{empresasNessaFaixa.length} </span>
              {empresasNessaFaixa.length <= 1 ? " CNPJ" : " CNPJs"} plano <br /> {faixa}ª Faixa
            </h2>
          </MDBCol>
        );
      });

    const tarefas_calc_pendentes = CentralStore.obs.tarefas_calc
      .filter(tarefa => tarefa.status === "Processando" || tarefa.status === "Novo")
      .reduce((acc, tarefa) => acc + tarefa.count, 0);

    return (
      <div className="dashboard-page">

        {AppStore.obs1.usuario &&
          <>
            <Dialog isOpen={this.obs.open_modal_retroativas} onClose={() => this.obs.open_modal_retroativas = false} title="Dados da Empresa" className="modalErrosDown">
              <div style={{ marginBottom: 10, maxHeight: 400, overflow: "auto" }} className="AlertImportacoes">
                {AppStore.obs1.empresasRetroativas?.map((el: IEmpresaRetroativa) => {
                  let empresa = EmpresaStore.getByCnpj(el.cnpj_destino)
                  if (empresa) {
                    return (<div className={Classes.DIALOG_BODY} key={el.cnpj_destino}>
                      <div onClick={() => this.handleCalculoICMS(el.cnpj_destino)} className="bloco-emp-erro">
                        <table style={{ width: '100%' }}>
                          <thead>
                            <tr>
                              <th style={{ width: '70%' }}>{empresa.razao_social}</th>
                              <th style={{ width: '5%', float: 'right' }}></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{el.cnpj_destino}</td>
                              <td>
                                <span className="badge-emp pulse badge-emp-calculo"></span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>)
                  }
                })
                }
              </div>
            </Dialog>

            <Dialog isOpen={this.obs.open_modal_erros_sefaz} onClose={() => this.obs.open_modal_erros_sefaz = false} title="Dados da Empresa" className="modalErrosDown">
              <div style={{ marginBottom: 10, maxHeight: 400, overflow: "auto" }} className="AlertImportacoes">
                {AppStore.obs1.empresaErrosSefaz?.map((el: IEmpresaErrosSefaz) => {
                  return <div className={Classes.DIALOG_BODY} key={el.cnpj}>
                    <div onClick={() => this.handleRedirectErrosSefaz(el)} className="bloco-emp-erro">
                      <table style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th style={{ width: '70%' }}>{el.razao_social}</th>
                            <th style={{ width: '5%', float: 'right' }}></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{el.cnpj}</td>
                            <td>
                              <span className="badge-emp pulse badge-emp-calculo"></span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                })
                }
              </div>
            </Dialog>

            <Dialog isOpen={this.obs.open_modal_divergentes} onClose={() => this.obs.open_modal_divergentes = false} title="Dados da Empresa" className="modalErrosDown">
              <div style={{ marginBottom: 10, maxHeight: 400, overflow: "auto" }} className="AlertImportacoes">
                {AppStore.obs1.empresaNotaDivergente?.map((el: IEmpresaRetroativa) => {
                  let empresa = EmpresaStore.getByCnpj(el.cnpj_destino)
                  if (empresa) {
                    return (
                      <div className={Classes.DIALOG_BODY} key={el.cnpj_destino}>
                        <div onClick={() => this.handleCalculoICMSDivergentes(el.cnpj_destino)} className="bloco-emp-erro">
                          <table style={{ width: '100%' }}>
                            <thead>
                              <tr>
                                <th style={{ width: '70%' }}>{empresa.razao_social}</th>
                                <th style={{ width: '5%', float: 'right' }}></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{el.cnpj_destino}</td>
                                <td>
                                  <span className="badge-emp pulse badge-emp-calculo"></span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )
                  }
                })
                }
              </div>
            </Dialog>

            <Dialog
              isOpen={this.obs.modalBemVindo}
              onClose={() => this.cancelAlert()}
              className="modal-bem-vindo"
              canEscapeKeyClose
              canOutsideClickClose
            >
              <div className="bem-vindo-container">
                <div className="bem-vindo-media">
                  <video className="bem-vindo-video" autoPlay loop muted playsInline>
                    <source src="/images/bem-vindo.mp4" type="video/mp4" />
                  </video>
                </div>

                <div className="bem-vindo-content">
                  <div className="bem-vindo-header">
                    <span className="bem-vindo-label">BEM-VINDO AO FIPO</span>
                    <h2>Que bom ter você por aqui!</h2>
                    <p>
                      Centralize sua operação fiscal e tenha mais segurança,
                      controle e inteligência na gestão dos seus clientes.
                    </p>
                  </div>

                  <div className="bem-vindo-beneficios">
                    <div className="beneficio-item">
                      <span>✓</span>Cálculos tributários mais assertivos
                    </div>
                    <div className="beneficio-item">
                      <span>✓</span>Inteligência tributária
                    </div>
                    <div className="beneficio-item">
                      <span>✓</span>Armazenamento de XMLs
                    </div>
                    <div className="beneficio-item">
                      <span>✓</span>Manifestação de NF-e
                    </div>
                  </div>

                  <div className="bem-vindo-divider" />

                  <p className="bem-vindo-subtitle">
                    Tudo o que você precisa para simplificar sua rotina:
                  </p>

                  <div className="bem-vindo-recursos">
                    <div className="recurso-item">
                      <div className="recurso-icon">
                        <img src="/images/safety.svg" />
                      </div>
                      <div>
                        <strong>Segurança de dados</strong>
                        <p>
                          Seus dados protegidos com uma estrutura preparada para
                          garantir segurança e disponibilidade das informações.
                        </p>
                      </div>
                    </div>

                    <div className="recurso-item">
                      <div className="recurso-icon">
                        <img src="/images/process.svg" />
                      </div>
                      <div>
                        <strong>Gestão inteligente</strong>
                        <p>
                          Identifique pendências, inconsistências e oportunidades
                          através da inteligência de dados do FIPO.
                        </p>
                      </div>
                    </div>

                    <div className="recurso-item">
                      <div className="recurso-icon">
                        <img src="/images/notification_action.svg" />
                      </div>
                      <div>
                        <strong>Controle centralizado</strong>
                        <p>
                          Gerencie os CNPJs da sua contabilidade e acompanhe suas
                          operações em um único lugar.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="bem-vindo-footer">
                    <MDBBtn className="btnDefault btnNaoMostrar" onClick={() => this.cancelAlert()}>Começar a usar o FIPO</MDBBtn>
                  </div>
                </div>
              </div>
            </Dialog>

            <Dialog isOpen={this.obs.empresasTrocaPlano} onClose={() => (this.obs.empresasTrocaPlano = false)} className="modalBooststrap modal-alteracoes">
              <div className={Classes.DIALOG_BODY}>
                <h2 className="title-cert">Alteração nos Planos!</h2>
                <p style={{ color: '#d95050' }}>
                  Identificamos que algumas empresas <b>excederam o limite estipulado de acordo com o plano contratado</b>.
                  Clique em <b>"Visualizar Mudanças"</b> abaixo para obter mais informações.
                </p>
              </div>
              <MDBCol md="12" className="button-group">
                <MDBBtn className="btnDefault btnBuscarNfe" onClick={this.viewMudancas}>Visualizar Mudanças</MDBBtn>
                <MDBBtn className="btnDefault btnNaoMostrar" style={{ float: 'right', marginLeft: '10px' }} onClick={() => this.notificacaoVisualizada()}>Não mostrar novamente</MDBBtn>
              </MDBCol>
            </Dialog>

            <Alert
              confirmButtonText="Fechar"
              isOpen={this.obs.modalEspaco}
              onConfirm={() => this.obs.modalEspaco = false}
              onClose={() => this.obs.modalEspaco = false}
              canOutsideClickCancel={true}
            >
              <h2 className="title-cert">Espaço Utilizado</h2>
              <div className="table-height" style={{ padding: 10 }}>
                <HTMLTable className="table table-hover" style={{ width: '100%' }}>
                  <thead>
                    <tr>
                      <th>Empresa</th>
                      <th>Espaço Utilizado</th>
                      <th>Espaço Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {empresas_espaco}
                  </tbody>
                </HTMLTable>
              </div>
            </Alert>

            <Dialog isOpen={this.obs.open_visualiza_descricao} onClose={() => this.obs.open_visualiza_descricao = false} className="modal-releases">

              <div className={Classes.DIALOG_CLOSE_BUTTON} style={{ textAlign: "right" }}>
                <IconButton onClick={() => AppStore.setLocation("/releases")}>
                  <AppIcon name='arrow_forward' style={{ color: "#3579ea" }} />
                </IconButton>
              </div>

              <div style={{ padding: "0px 0px 15px 0px" }}>

                <div dangerouslySetInnerHTML={{ __html: this.obs.description }} />

              </div>

              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <MDBBtn className="btnDefault" onClick={() => this.obs.open_visualiza_descricao = false}>Fechar</MDBBtn>
                &nbsp;&nbsp;
                <MDBBtn className="btnDefault btnNaoMostrar" onClick={() => this.handleEntendi()}>Entendi</MDBBtn>
              </div>

            </Dialog>

            <MDBRow className="DashboardContent">

              <MDBCol xl="6" lg="12" md="12">
                <MDBRow>
                  <MDBCol xl="12" lg="12" md="12" sm="12" xs="12">
                    <h2 className="title">Itens Calculados x Importação Erros ({moment().format('YYYY')})</h2>
                    <div className="graph-nfe-dash" data-tut="reactour__graph">
                      {this.handleGrafico()}
                    </div>
                  </MDBCol>
                </MDBRow>
              </MDBCol>

              <MDBCol xl="3" lg="12" md="12">
                <div className="statusDash">
                  <h2 onClick={() => this.handleGoCentralAcoes()} className="title central_acoes"> <img className="icon_central" src='/images/notificacoes.svg' width={"27px"} /> Central de Ações</h2>
                  {/* <h2 className="title central_acoes">{"\u200B"}</h2> */}
                  <MDBRow>
                    <MDBCol xl="6" lg="6" md="6">
                      <div className={CentralStore.obs.total_nao_calculado <= 0 ? "area-status-erros-calculo area-status-sem-erros-calculo" : "area-status-erros-calculo"} onClick={this.handleGoErros}>
                        <span className="topo-title">Erros de <br /> Cálculo</span>
                        <span className="fundo-title">
                          {CentralStore.obs.total_nao_calculado >= 1 ?
                            <>Você possui <u>{CentralStore.obs.total_nao_calculado} {CentralStore.obs.total_nao_calculado <= 1 ? "Item não calculado." : "Itens não calculados."}</u></>
                            :
                            <>Todos os seus cálculos estão corretos! 😊</>
                          }
                        </span>
                      </div>
                    </MDBCol>
                    <MDBCol xl="6" lg="6" md="6">
                      <div className={tarefas_calc_pendentes <= 0 ? "area-status-erros area-status-sem-erros-calculo" : "area-status-erros area-status-pendente-calculo"} onClick={this.handleGoResultados}>
                        <span className="topo-title">Tarefas de <br /> Cálculo</span>
                        <span className="fundo-title">
                          {tarefas_calc_pendentes >= 1 ?
                            <>Você possui <u>{tarefas_calc_pendentes} {tarefas_calc_pendentes <= 1 ? "Tarefa" : "Tarefas"}</u> {tarefas_calc_pendentes <= 1 ? "pendente" : "pendentes"}.</>
                            :
                            <>Todas tarefas estão ok.</>
                          }
                        </span>
                      </div>
                    </MDBCol>
                    <MDBCol xl="6" lg="6" md="6">
                      <div className={AppStore.obs1.instavel ? "area-status-sefaz usadas" : "area-status-sefaz"} data-tut="reactour__sefaz">
                        <span className="topo-title">Status <br /> SEFA</span>
                        <span className="fundo-title">
                          {AppStore.obs1.instavel ?
                            "Instável: possíveis atrasos em suas solicitações e downloads."
                            :
                            "Estável"
                          }
                        </span>
                      </div>
                    </MDBCol>
                    <MDBCol md="6" onClick={this.handleModalEspaco} className="pointer">
                      <div className={this.obs.countArmaz >= 1 ? "area-status-dados armazenamento-final" : "area-status-dados"} data-tut="reactour__assinatura">
                        <span className="topo-title">Armazenamento <br /> XMLs</span>
                        <span className="fundo-title">
                          Visualize os armazenamentos
                        </span>
                      </div>
                    </MDBCol>
                  </MDBRow>
                </div>
              </MDBCol>

              <MDBCol xl="3" lg="12" md="12">
                <div className="nfesManifestadas">
                  <MDBRow>
                    <MDBCol md="12">
                      <div className="temp-nfes-manif main-temp-nfes-manif not-cursor">
                        <p>
                          <img src="/images/ciencia-white.png" width="25px;" className="icon-bloco" />
                          <span>Total NF-es Manifestadas</span>
                          <b>{this.obs.total}</b>
                        </p>
                      </div>
                    </MDBCol>
                    <MDBCol md="12" className="temp-men">
                      <div className="temp-nfes-manif">
                        <p className="itens-dash">
                          <img src="/images/ciencica.png" width="30px;" className="icon-bloco" />
                          <span>Apenas Ciência</span>
                          <b>{this.obs.ciencia}</b>
                        </p>
                      </div>
                    </MDBCol>
                    <MDBCol md="12" className="temp-men">
                      <div className="temp-nfes-manif">
                        <p className="itens-dash">
                          <img src="/images/confirmada.png" width="30px;" className="icon-bloco" />
                          <span>Confirmadas</span>
                          <b>{this.obs.confirmadas}</b>
                        </p>
                      </div>
                    </MDBCol>
                    <MDBCol md="12" className="temp-men">
                      <div className="temp-nfes-manif">
                        <p className="itens-dash">
                          <img src="/images/desconhecidas.png" width="30px;" className="icon-bloco" />
                          <span>Desconhecidas</span>
                          <b>{this.obs.desconhecidas}</b>
                        </p>
                      </div>
                    </MDBCol>

                    <MDBCol md="12" className="temp-men">
                      <div className="temp-nfes-manif">
                        <p className="itens-dash">
                          <img src="/images/nao_realizadas.png" width="30px;" className="icon-bloco" />
                          <span>Não Realizadas</span>
                          <b>{this.obs.nao_realizadas}</b>
                        </p>
                      </div>
                    </MDBCol>

                    <MDBCol md="12" className="temp-men" onClick={() => this.handleOpenErrosSefaz()}>

                      <div className="temp-nfes-manif" >

                        <p className="itens-dash">
                          <img src="/images/arrow.svg" width="25px;" className="icon-bloco" />
                          <span className={AppStore.obs1.empresaErrosSefaz.length > 0 ? "hvr-buzz" : ""}>Erros sefaz</span>
                          <b>( {AppStore.obs1.empresaErrosSefaz.length} ) Empresa</b>
                        </p>
                      </div>
                    </MDBCol>

                    <MDBCol md="12" className="temp-men" onClick={() => this.handleOpenRetroativas()}>

                      <div className="temp-nfes-manif" >

                        <p className="itens-dash">
                          <img src="/images/arrow.svg" width="25px;" className="icon-bloco" />
                          <span className={AppStore.obs1.empresasRetroativas.length > 0 ? "hvr-buzz" : ""}>Notas Retroativas</span>
                          <b>( {AppStore.obs1.empresasRetroativas.length} ) Empresa</b>
                        </p>
                      </div>
                    </MDBCol>

                    <MDBCol md="12" className="temp-men" onClick={() => this.handleOpenNotasDivergentes()}>

                      <div className="temp-nfes-manif" >

                        <p className="itens-dash">
                          <img src="/images/arrow.svg" width="25px;" className="icon-bloco" />
                          <span className={AppStore.obs1.empresaNotaDivergente.length > 0 ? "hvr-buzz" : ""}>Notas Divergentes (data)</span>
                          <b>( {AppStore.obs1.empresaNotaDivergente.length} ) Empresa</b>
                        </p>
                      </div>
                    </MDBCol>



                  </MDBRow>
                </div>
              </MDBCol>

              <MDBCol xl="3" lg="6" md="6">
                <div className="dados-conta">
                  <MDBRow>
                    <MDBCol md="2">
                      <img src="/images/empresas.png" width="42px;" className="icon-bloco" />
                    </MDBCol>
                    <MDBCol md="7">
                      <h2>
                        &nbsp;
                        <span>CNPJs</span>
                      </h2>
                    </MDBCol>
                    <MDBCol md="3" onClick={this.handleGoEmpresa} className="cursor-link arrow-link">
                      <img src="/images/arrow.svg" width="38px;" className="icon-bloco" />
                    </MDBCol>
                    <MDBCol md="12">
                      <h2 className="count_total_second">
                        <span className="big-number">{numeral(AppStore.obs1.stats.empresa_count).format('0,0')} </span>
                        / cadastrado(s)
                      </h2>
                    </MDBCol>
                    <MDBCol md="12">
                      <h2 className="count_total_second">
                        <span className="big-number">{numeral(AppStore.obs1.stats.empresa_count_ativas).format('0,0')} </span>
                        / ativo(s)
                      </h2>
                    </MDBCol>
                    <MDBCol md="12">
                      <h2 className="count_total_second">
                        <span className="big-number">{numeral(AppStore.obs1.stats.empresa_count_inativas).format('0,0')} </span>
                        / desativado(s)
                      </h2>
                    </MDBCol>
                  </MDBRow>
                </div>
              </MDBCol>

              <MDBCol xl="3" lg="6" md="6">
                <div className="dados-conta">
                  <MDBRow>
                    <MDBCol md="2">
                      <img src="/images/cert.png" width="42px;" className="icon-bloco" />
                    </MDBCol>
                    <MDBCol md="7">
                      <h2>
                        Certificados
                        <span>digitais</span>
                      </h2>
                    </MDBCol>
                    <MDBCol md="3" onClick={this.handleGoEmpresa} className="cursor-link arrow-link">
                      <img src="/images/arrow.svg" width="38px;" className="icon-bloco" />
                    </MDBCol>
                    <MDBCol md="12">
                      <h2 className="count_total_second" onClick={() => this.handleRedirctEmpresas("2")} style={{ cursor: "pointer" }}>
                        <span className="big-number">{numeral(AppStore.obs1.stats.cert_count).format('0,0')}</span>
                        / cadastrado(s)
                      </h2>
                      <h2 className="count_total_second" onClick={() => this.handleRedirctEmpresas("0")} style={{ cursor: "pointer" }}>
                        <span className="big-number">{numeral(AppStore.obs1.stats.empresas_sem_certificado).format('0,0')}</span>
                        / sem certificado
                      </h2>
                      {AppStore.obs1.stats.cert_venc > 0 ?
                        <h2 className="count_total_second hvr-buzz alert-cert" onClick={() => this.handleRedirctEmpresas("1")} style={{ cursor: "pointer" }}>
                          <span className="big-number">{numeral(AppStore.obs1.stats.cert_venc).format('0,0')}</span>
                          / expirado(s)
                        </h2>
                        :
                        <h2 className="count_total_second" onClick={() => this.handleRedirctEmpresas("1")} style={{ cursor: "pointer" }}>
                          <span className="big-number">{numeral(AppStore.obs1.stats.cert_venc).format('0,0')}</span>
                          / expirado(s)
                        </h2>
                      }
                    </MDBCol>
                  </MDBRow>
                </div>
              </MDBCol>

              <MDBCol xl="6" lg="12" md="6">
                <div className="dados-conta dados-planos">
                  <MDBRow>
                    <MDBCol md="1">
                      <img src="/images/planos.png" width="42px;" className="icon-bloco" />
                    </MDBCol>
                    <MDBCol md="8">
                      <h2>
                        Sua
                        <span>assinatura</span>
                      </h2>
                    </MDBCol>
                    <MDBCol md="3" onClick={this.handleGoPerfil} className="cursor-link arrow-link">
                      <img src="/images/arrow.svg" width="38px;" className="icon-bloco" />
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    {itens}
                    {PerfilStore.obs.empresas_planos_personalizados.length > 0 &&
                      <MDBCol md="2">
                        <h2 className="count_total_second">
                          <span className="big-number">{PerfilStore.obs.empresas_planos_personalizados.length} </span>
                          {PerfilStore.obs.empresas_planos_personalizados.length <= 1 ? " CNPJ" : " CNPJs"} plano <br /> Personalizado
                        </h2>
                      </MDBCol>
                    }
                  </MDBRow>
                </div>
              </MDBCol>

            </MDBRow>
          </>
        }

        <div style={{ marginTop: 5, marginBottom: 100 }}></div>

      </div>

    );
  }
}

export default DashboardPage;
